import styled from '@emotion/styled';
import { Container } from '@mui/material';
import Theme from '../../App.theme';

export const CardContainer = styled(Container)`
  margin: 0 auto;
  padding: ${Theme.layout.spacing.large};
  border-radius: 5px;
  box-shadow: none;
  align-items: center;
  background-color: ${Theme.colours.white};
  position: relative;
`;
